import { render, staticRenderFns } from "./ModalSupprimer.vue?vue&type=template&id=4b0cec00&scoped=true&"
import script from "./ModalSupprimer.vue?vue&type=script&lang=js&"
export * from "./ModalSupprimer.vue?vue&type=script&lang=js&"
import style0 from "./ModalSupprimer.vue?vue&type=style&index=0&id=4b0cec00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0cec00",
  null
  
)

export default component.exports